import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { Progress } from '../ui/progress';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Select from 'src/components/ui/BrandSelect';
import { Actions as USAGEACTIONS } from '../../store/actions/usageActions';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import Breadcrumb from '../Common/Breadcrumb';
import { Calendar, Settings, Sofa, Car, Fuel, Factory, Scale, Trash2, MapPin, TreePine, Leaf, TrendingUp, TriangleAlert, ArrowRight } from 'lucide-react';
import { itemToOptions } from '../utils/GlobalFunctions';

function allAreNull(array) {
  let result = true;

  for (const value of array) {
    if (value !== null) {
      result = false;
      break;
    }
  }

  return result;
}

function dateDiff(first, second) {
  return Math.round((second - first) / (1000 * 60 * 60 * 24));
}

const BulkEditPage = ({ entityName, entityId, checkedUsage, options, saveUsageData, branding, progressState }) => {
  const [checkedConfirm, setCheckedConfirm] = useState(false);
  const [selected, setSelected] = useState({});
  const [editAreaActive, setEditAreaActive] = useState(false);
  const [progressBarActive, setProgressBarActive] = useState(false);
  const [invalidUsageDate, setInvalidUsageDate] = useState(false);
  const [progress, setProgress] = useState(0);
  const history = useHistory();
  const { primaryColor } = branding.colors;

  useEffect(() => {
    if (progressState !== undefined) {
      setProgress(progressState);
      setProgressBarActive(true);
    } else {
      setProgressBarActive(false);
    }
  }, [progressState]);

  useEffect(() => {
    if (entityId === undefined && !progressBarActive) {
      history.push('/usage');
    }
    //eslint-disable-next-line
  }, [entityId]);

  const updateDateOrSelect = (selectedInput, e) => {
    if (e) {
      const newSelected = { ...selected };
      newSelected[e.name] = selectedInput;
      setSelected(newSelected);
    }
  };

  const updateTextInput = (e) => {
    if (e) {
      const newSelected = { ...selected };
      const result = e.target.name === 'Usage Value' ? e.target.value.replace(/[^0-9_.]/g, '') : e.target.value;
      if (typeof result === 'string' && result.trim().length === 0) {
        newSelected[e.target.name] = null;
      } else {
        newSelected[e.target.name] = result;
      }
      setSelected(newSelected);
    }
  };

  const newData = () => {
    const newItem = {};
    Object.keys(selected).forEach((optionType) => {
      if (optionType === 'Start Date') {
        newItem['dateStart'] = selected[optionType];
      } else if (optionType === 'End Date') {
        newItem['dateEnd'] = selected[optionType];
      } else if (optionType === 'Custom top-level category') {
        newItem['userLabel'] = selected[optionType];
      } else if (optionType === 'Usage Value') {
        newItem['usage'] = selected[optionType];
      } else {
        newItem[optionType] = selected[optionType]['value']?.toString();
      }
    });
    return checkedUsage?.map((oldItem) => {
      const newUD = { id: oldItem.id.toString(), ...oldItem, ...newItem };
      return newUD;
    });
  };

  return (
    <>
      {!progressBarActive && (
        <Breadcrumb
          items={[
            { label: 'Usage', link: '/usage' },
            { label: entityName, link: `/usage/` + entityId },
          ]}
        />
      )}

      {!editAreaActive && (
        <div className='row'>
          <div className='col-lg-12'>
            <section className='panel'>
              <aside className='profile-nav alt'>
                <section className='panel'>
                  <header className='panel-heading'>Bulk Edit - {entityName}</header>
                  <ul className='nav nav-pills nav-stacked'>
                    {Object.keys(options).map((optionType, index) => (
                      <>
                        {options[optionType] === 'date' && (
                          <li key={index}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '10px 15px',
                              }}>
                              <div>
                                <Calendar size={16} strokeWidth={1.5} style={{ paddingRight: 20, minWidth: 36 }} />
                                {optionType}
                              </div>
                              <span style={{ float: 'right' }}>
                                <style> {`.react-datepicker__input-container{ width: 20vh }`} </style>
                                <label className='input-group date datepicker'>
                                  <DatePicker
                                    showMonthDropdown
                                    showYearDropdown
                                    dateFormat='dd/MM/yyyy'
                                    name={optionType}
                                    selected={selected[optionType]}
                                    onChange={(selectedDate, e) => {
                                      e.name = optionType;
                                      updateDateOrSelect(selectedDate, e);
                                      setInvalidUsageDate(false);
                                    }}
                                    minDate={optionType === 'End Date' && selected['Start Date']}
                                    maxDate={new Date()}
                                    className='h-9 w-full rounded-lg border border-input bg-transparent px-3 py-2 text-sm date'
                                    wrapperClassName='date-picker'
                                    popperPlacement='bottom-end'
                                    popperModifiers={{
                                      offset: {
                                        enabled: true,
                                        offset: '77px, 0px',
                                      },
                                    }}
                                  />
                                  <span className='input-group-btn'>
                                    <Button variant='ghost' size='sm'>
                                      {' '}
                                      <Calendar size={16} strokeWidth={1.5} />{' '}
                                    </Button>
                                  </span>
                                </label>
                              </span>
                            </div>
                          </li>
                        )}
                        {options[optionType] === 'text' && (
                          <li key={index}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '10px 15px',
                              }}>
                              <div>
                                <Settings size={16} strokeWidth={1.5} style={{ paddingRight: 20, minWidth: 36 }} />
                                {optionType}
                              </div>
                              <span style={{ float: 'right' }}>
                                <div className='form-group' style={{ marginBottom: '0' }}>
                                  <div style={{ width: '23.5vh' }}>
                                    <Input
                                      type='text'
                                      className='h-[37px] w-full'
                                      name={optionType}
                                      onChange={(e) => {
                                        updateTextInput({ target: { name: optionType, value: e.target.value } });
                                      }}
                                      value={selected[optionType] || ''}
                                    />
                                  </div>
                                </div>
                              </span>
                            </div>
                          </li>
                        )}
                        {Array.isArray(options[optionType]) && (
                          <li key={index}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '10px 15px',
                              }}>
                              <div>
                                {optionType === 'seat' && <Sofa size={16} strokeWidth={1.5} style={{ paddingRight: 20, minWidth: 36 }} />}
                                {optionType === 'vehicle' && (
                                  <Car size={16} strokeWidth={1.5} style={{ paddingRight: 20, minWidth: 36 }} />
                                )}
                                {optionType === 'fuel' && (
                                  <Fuel size={16} strokeWidth={1.5} style={{ paddingRight: 20, minWidth: 36 }} />
                                )}
                                {optionType === 'production' && (
                                  <Factory size={16} strokeWidth={1.5} style={{ paddingRight: 20, minWidth: 36 }} />
                                )}
                                {optionType === 'load' && (
                                  <Scale size={16} strokeWidth={1.5} style={{ paddingRight: 20, minWidth: 36 }} />
                                )}
                                {optionType === 'waste' && (
                                  <Trash2 size={16} strokeWidth={1.5} style={{ paddingRight: 20, minWidth: 36 }} />
                                )}
                                {optionType === 'facility' && (
                                  <MapPin size={16} strokeWidth={1.5} style={{ paddingRight: 20, minWidth: 36 }} />
                                )}
                                {optionType === 'entity' && (
                                  <TreePine size={16} strokeWidth={1.5} style={{ paddingRight: 20, minWidth: 36 }} />
                                )}
                                {optionType === 'subentity' && (
                                  <Leaf size={16} strokeWidth={1.5} style={{ paddingRight: 20, minWidth: 36 }} />
                                )}
                                {optionType === 'metric' && (
                                  <TrendingUp size={16} strokeWidth={1.5} style={{ paddingRight: 20, minWidth: 36 }} />
                                )}
                                {optionType.charAt(0).toUpperCase() + optionType.slice(1)}
                              </div>
                              <span style={{ float: 'right' }}>
                                <div style={{ width: '23.5vh' }}>
                                  <Select
                                    name={optionType}
                                    options={options[optionType]}
                                    onChange={(selectedOption, e) => {
                                      updateDateOrSelect(selectedOption, e);
                                    }}
                                    value={selected[optionType]}
                                    isClearable={true}
                                  />
                                </div>
                              </span>
                            </div>
                          </li>
                        )}
                      </>
                    ))}
                  </ul>
                </section>
              </aside>
            </section>
            {!allAreNull(Object.values(selected)) && (
              <div style={{ display: 'grid', placeItems: 'center' }}>
                <span
                  id='dateSpan-warning'
                  style={{
                    display: invalidUsageDate ? 'block' : 'none',
                    color: 'red',
                    fontWeight: 'bold',
                    marginBottom: '2vh',
                  }}>
                  <TriangleAlert size={16} strokeWidth={1.5} style={{ color: 'red' }} />
                  {''}Your date span cannot exceed 1 year!
                </span>
                <Button
                  onClick={() => {
                    var datesDiff = 0;

                    if (selected['Start Date'] && selected['End Date']) {
                      datesDiff = dateDiff(selected['Start Date'], selected['End Date']);
                    }

                    if (datesDiff > 364) {
                      setInvalidUsageDate(true);
                    } else {
                      setEditAreaActive(true);
                    }
                  }}>
                  Next
                </Button>
              </div>
            )}
          </div>
        </div>
      )}

      {editAreaActive && (
        <>
          {!progressBarActive && (
            <div className='changesArea'>
              <div className='row'>
                <div className='col-lg-12'>
                  <section className='panel'>
                    <aside className='profile-nav alt'>
                      <section className='panel'>
                        <header className='panel-heading'>Your Selected Changes for {entityName}</header>
                        <ul className='nav nav-pills nav-stacked'>
                          {Object.keys(selected).map((key, index) => (
                            <>
                              {selected[key] !== null && (
                                <li key={key}>
                                  <div style={{ display: 'flex', padding: '10px 15px' }}>
                                    <div style={{ width: '45%', marginRight: '5%', textAlign: 'end' }}>
                                      {key.charAt(0).toUpperCase() + key.slice(1)}
                                    </div>
                                    <div style={{ marginRight: '5%' }}>
                                      <ArrowRight size={16} strokeWidth={1.5} />
                                    </div>
                                    <div style={{ width: '45%' }}>
                                      {selected[key]?.label && <div>{selected[key]?.label}</div>}
                                      {key.includes('Date') && <div>{moment(selected[key]).format('DD/MM/YYYY')}</div>}
                                      {!key.includes('Date') && !selected[key]?.label && <div>{selected[key]}</div>}
                                    </div>
                                  </div>
                                </li>
                              )}
                            </>
                          ))}
                        </ul>
                      </section>
                    </aside>
                  </section>
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-12'>
                  <section className='panel'>
                    <aside className='profile-nav alt'>
                      <section className='panel'>
                        <header className='panel-heading'>Your Previous Records for {entityName}</header>
                        <style>
                          {`
                        td {
                          font-family: inherit;
                          font-size: inherit;
                          color: inherit;
                        }
                      `}
                        </style>
                        <div style={{ maxHeight: '50vh' }} className="panel-body overflow-auto">
                          <Table className="w-full" aria-label="simple table">
                            <TableHeader>
                              <TableRow>
                                <TableHead className="text-center">Facility</TableHead>
                                <TableHead className="text-center">Start Date</TableHead>
                                <TableHead className="text-center">End Date</TableHead>
                                <TableHead className="text-center">Entity Name</TableHead>
                                <TableHead className="text-center">Subentity Name</TableHead>
                                <TableHead className="text-center">Usage Value</TableHead>
                                <TableHead className="text-center">Seat</TableHead>
                                <TableHead className="text-center">Vehicle</TableHead>
                                <TableHead className="text-center">Fuel</TableHead>
                                <TableHead className="text-center">Production</TableHead>
                                <TableHead className="text-center">Waste</TableHead>
                                <TableHead className="text-center">Metric</TableHead>
                                <TableHead className="text-center">Load</TableHead>
                              </TableRow>
                            </TableHeader>
                            <TableBody>
                              {checkedUsage?.map((row) => (
                                <TableRow key={row.name}>
                                  <TableCell className="text-center">{row.facilityName}</TableCell>
                                  <TableCell className="text-center">{moment(row.dateStart).format('DD/MM/YYYY')}</TableCell>
                                  <TableCell className="text-center">{moment(row.dateEnd).format('DD/MM/YYYY')}</TableCell>
                                  <TableCell className="text-center">{row.entityName}</TableCell>
                                  <TableCell className="text-center">{row.subentityName}</TableCell>
                                  <TableCell className="text-center">{row.usage + ' ' + row.metricName}</TableCell>
                                  <TableCell className="text-center">{row.seatName}</TableCell>
                                  <TableCell className="text-center">{row.vehicleName}</TableCell>
                                  <TableCell className="text-center">{row.fuelName}</TableCell>
                                  <TableCell className="text-center">{row.productionName}</TableCell>
                                  <TableCell className="text-center">{row.wasteName}</TableCell>
                                  <TableCell className="text-center">{row.metricName}</TableCell>
                                  <TableCell className="text-center">{row.loadName}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </div>
                      </section>
                    </aside>
                  </section>
                </div>
              </div>
              <div className="flex justify-center">
                <div className="flex items-center gap-2">
                  <Checkbox
                    id="bulk-edit-confirm"
                    checked={checkedConfirm}
                    onCheckedChange={setCheckedConfirm}
                  />
                  <Label htmlFor="bulk-edit-confirm">By clicking you confirm the changes above are correct.</Label>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button variant='outline' onClick={() => setEditAreaActive(false)}>
                  Back
                </Button>
                <Button
                  style={{ marginLeft: 10 }}
                  disabled={!checkedConfirm}
                  onClick={() => {
                    setProgressBarActive(true);
                    const dataToBePassed = newData();
                    saveUsageData(dataToBePassed);
                  }}>
                  Confirm
                </Button>
              </div>
            </div>
          )}
          {progressBarActive && (
            <div className='progressBarArea'>
              <div className='row'>
                <div className='col-lg-12'>
                  <section className='panel'>
                    <aside className='profile-nav alt'>
                      <section className='panel'>
                        <div className="w-full p-12">
                          <div className="flex items-center gap-4 min-h-[10vh]">
                            <Progress value={progress} className="h-2 rounded flex-1 max-w-[90%]" />
                            <span className="min-w-[35px] text-sm text-muted-foreground">{`${Math.round(progress)}%`}</span>
                          </div>
                          {progress === 100 && (
                            <div className="flex flex-col items-center gap-2">
                              <p>Usage has been bulk edited Successfully!</p>
                              <Button onClick={() => history.push('/usage')}>
                                Back to Usage Data
                              </Button>
                            </div>
                          )}
                        </div>
                      </section>
                    </aside>
                  </section>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const checkedUsage = state?.admin?.checkboxes?.checkedUsage;

  const entityId = checkedUsage?.[0]?.entity;
  const entityName = checkedUsage?.[0]?.entityName;

  const options = { 'Start Date': 'date', 'End Date': 'date', 'Custom top-level category': 'text', 'Usage Value': 'text' };
  const optionTypes = state?.metric?.types;
  const subentity = state?.subentities;
  const metric = state?.metric?.list;

  optionTypes &&
    Object.keys(optionTypes)?.map((item) => {
      options[item] = optionTypes[item].map(itemToOptions)?.sort((a, b) => a.label.localeCompare(b.label));
      return options;
    });

  options.facility =
    state?.facility?.list &&
    _.uniqBy(state?.facility?.list, 'id')
      .map(itemToOptions)
      .sort((a, b) => (a.label > b.label ? 1 : -1));

  options.entity = state?.entities?.map(itemToOptions)?.sort((a, b) => (a.label > b.label ? 1 : -1));

  options.subentity = subentity?.map(itemToOptions)?.sort((a, b) => a.label.localeCompare(b.label));
  options.metric = metric?.map(itemToOptions)?.sort((a, b) => a.label.localeCompare(b.label));

  return {
    entityId,
    entityName,
    subentities: state?.subentities,
    cyfAdmin: state.profile?.details?.cyfAdmin,
    checkedUsage,
    options,
    branding: state?.branding,
    progressState: state?.progress,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveUsageData: (usageData) => dispatch(USAGEACTIONS.saveUsageData(usageData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkEditPage);
